import { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactImageGallery from "react-image-gallery";
import imgs from "./temp.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faBath,
  faBed,
  faClock,
  faEnvelope,
  faPhone,
  faRulerCombined,
} from "@fortawesome/free-solid-svg-icons";
import professional from "../assets/images/Smiling_Professional-min.jpg";
import constants from "../constants/constants";
import placeholder from "../assets/images/house-placeholder.webp";
import { pageSEO, SEO } from "../components/seo.component";
import isReactSnap from "../utils/isReactSnap";

export default function Listing() {
  const proxyUrl = "https://cors-anywhere.herokuapp.com/";
  const [popup, setPopup] = useState(false);
  const formRef = useRef(null);
  const [formData, setFormData] = useState({
    Name: "",
    "Email Address": "",
    Message: "",
  });

  // Add validation state
  const [formErrors, setFormErrors] = useState({
    Name: "",
    "Email Address": "",
    Message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Form validation function
  const validateForm = () => {
    const errors = {};

    // Check if Name is empty
    if (!formData.Name.trim()) {
      errors.Name = "Name is required";
    }

    // Check if Email is empty and valid format
    if (!formData["Email Address"].trim()) {
      errors["Email Address"] = "Email is required";
    } else if (!validateEmail(formData["Email Address"])) {
      errors["Email Address"] = "Please enter a valid email address";
    }

    // Check if Message is empty
    if (!formData.Message.trim()) {
      errors.Message = "Message is required";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  async function submitForm(event) {
    console.log("submitForm");
    event.preventDefault();

    // Validate form before submission
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    console.log("process.env.REACT_APP_AGENT_EMAIL");
    console.log(process.env.REACT_APP_AGENT_EMAIL);

    const emailFormData = new FormData();
    emailFormData.append('data', JSON.stringify({
      recipientEmails: [constants.AGENT_EMAIL],
      senderEmail: process.env.REACT_APP_AGENT_EMAIL,
      subject: "New Contact Form Message",
      content: formData.Message,
      senderName: formData.Name,
      replyTo: formData["Email Address"],
    }));

    let EmailApiUrl = process.env.REACT_APP_NODE_ENV === "production" ? "https://3.138.143.209/global/send-email" : "http://3.138.143.209/global/send-email";


    try {
      const response = await fetch(EmailApiUrl, {
        method: "POST",
        body: emailFormData,
      });

      if (!response.ok) {
        throw new Error("Failed to send email");
      }

      const res = await response.json();
      console.log("res", res);

      if (res?.message === "success") {
        console.log("Success", res);
        setPopup({
          subject: "Thanks for your message!",
          message: "We will get back to you as soon as possible",
        });
        // Clear form after successful submission
        setFormData({
          Name: "",
          "Email Address": "",
          Message: "",
        });
        // Clear errors after successful submission
        setFormErrors({
          Name: "",
          "Email Address": "",
          Message: "",
        });
      } else {
        setPopup({
          subject: "We encountered an error in sending this message",
          message: "Please try again later",
        });
      }
    } catch (err) {
      console.log(err);
      setPopup({
        subject: "We encountered an error in sending this message",
        message: "Please try again later",
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  const { id } = useParams();
  const [property, setProperty] = useState({});
  const photos = useRef([]);
  const [media, setMedia] = useState(imgs.full.value);
  const [formatted, setFormatted] = useState({});
  const loaded = useRef(false);
  const loadedRef = useRef(false);
  const [defaultMessage, setDefaultMessage] = useState(
    `Hello, I recently came across a listing and would like more information.`
  );
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  function formatStr(str) {
    const result = str
      .replaceAll(" ", "(S)")
      .replaceAll("&", "(A)")
      .replaceAll("?", "(Q)");

    return result;
  }

  function getData() {
    var body = {
      url: `https://query.ampre.ca/odata/Property?$filter=ListingKey eq '${id}'`,
      needAuth: true,
      bearerToken: constants.TOKEN,
    };
    return new Promise(async (resolve, reject) => {
      try {
        let data =
          constants.ENVIRONMENT === "production"
            ? await fetch(`${constants.URL_PROD}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            })
            : await fetch(`http://${constants.URL}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            });
        if (data.ok) {
          let res = await data.json();
          resolve(res);
        } else {
          reject("Failed to fetch data");
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function formatMedia(media) {
    if (!media?.length) {
      return Array(6).fill({ original: placeholder, thumbnail: placeholder });
    }
    var temp1 = {};

    for (let img of media) {
      if (temp1[img.MediaObjectID]) {
        temp1[img.MediaObjectID] = {
          ...temp1[img.MediaObjectID],
          [img.ImageSizeDescription]: img,
        };
      } else {
        temp1[img.MediaObjectID] = { [img.ImageSizeDescription]: img };
      }
    }
    var temp = [];
    for (let [k, v] of Object.entries(temp1)) {
      temp.push({
        original: v?.LargestNoWatermark?.MediaURL,
        thumbnail: v?.Thumbnail?.MediaURL,
      });
    }

    return temp;
  }

  function getMedia() {
    var body = {
      url: `https://query.ampre.ca/odata/Media?$filter=ResourceRecordKey eq '${id}' and (ImageSizeDescription eq 'LargestNoWatermark' or ImageSizeDescription eq 'Thumbnail')`,
      needAuth: true,
      bearerToken: constants.TOKEN,
    };
    return new Promise(async (resolve, reject) => {
      try {
        let data =
          constants.ENVIRONMENT === "production"
            ? await fetch(`${constants.URL_PROD}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            })
            : await fetch(`http://${constants.URL}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            });
        if (data.ok) {
          let res = await data.json();
          resolve(res);
        } else {
          reject("Failed to fetch data");
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  useEffect(() => {
    if (isReactSnap()) return; // Skip fetching during react-snap
    if (!loadedRef.current) {
      loadedRef.current = true;
      getData()
        .then((data) => {
          setProperty(data.value[0]);
          setFormData((prev) => ({
            ...prev,
            Message: `Hello, I recently came across a listing at ${data.value[0]?.StreetNumber ?? "--"
              } ${data.value[0]?.StreetName ?? "--"} ${data.value[0]?.StreetSuffix ?? ""
              } and would like more information.`,
          }));
        })
        .catch((err) => {
          console.log(err);
        });
      getMedia()
        .then((data) => {
          photos.current = data.value;
          setImages(formatMedia(data.value));
        })
        .catch((err) => {
          console.log(err);
        });

      loaded.current = true;
    }
  }, []);
  const [images, setImages] = useState([]);

  // useEffect(() => {
  //     var temp = []
  //     for (let img of Object.values(formatted)) {
  //         for (let [k, v] of Object.entries(img)) {
  //             temp.push({ original: v?.LargestNoWatermark?.MediaURL, thumbnail: v?.Thumbnail?.MediaURL })

  //         }

  //     }
  //     setImages(temp)
  //     console.log(temp)
  // }, [formatted])

  const [detailsOpen, setDetailsOpen] = useState(false);

  const seoConfig = pageSEO.listing(property);

  return (
    <>
      <SEO {...seoConfig}>
        {/* Add structured data as children */}
        {seoConfig.structuredData && (
          <script type="application/ld+json">
            {JSON.stringify(seoConfig.structuredData)}
          </script>
        )}
      </SEO>
      <div className="max-w-[1400px] mx-auto px-8 sm:w-[75vw] pt-[100px]">
        <div className="flex justify-between pt-8 pb-6 items-end gap-x-10 gap-y-6 flex-wrap">
          <div>
            <h1 className="text-4xl text-black libre ">
              {property?.StreetNumber} {property?.StreetName}{" "}
              {property?.StreetSuffix}
            </h1>
            <p className="text-med-grey text-2xl mt-2">
              {property?.City} {property?.StateOrProvince},{" "}
              {property?.PostalCode}
            </p>
          </div>
          <div className="flex flex-col lg:items-end whitespace-nowrap">
            <h1 className="font-semibold text-xl text-black">
              <span className="text-logo-second">Listing Price:</span>{" "}
              {property?.ListPrice?.toLocaleString()}
            </h1>
            <p className="font-semibold mt-2 text-med-grey text-lg">
              {" "}
              <FontAwesomeIcon
                className="text-logo-second mr-1"
                icon={faClock}
              />{" "}
              Listed on{" "}
              {property?.OriginalEntryTimestamp
                ? new Date(property?.OriginalEntryTimestamp).toLocaleString(
                  "default",
                  { month: "short", day: "numeric", year: "numeric" }
                )
                : "--"}
            </p>
          </div>
        </div>
        <div className="flex gap-x-8 justify-between h-fit">
          <div className="min-[1201px]:w-[80%]">
            <ReactImageGallery
              items={images}
              loading={"eager"}
              thumbnailPosition={`${windowSize > 950 ? "right" : "bottom"}`}
              showThumbnails={windowSize > 950 ? true : false}
              showPlayButton={false}
            />
            <div className="w-full px-3 py-2 bg-logo-second mt-5">
              <span className="text-white font-semibold ">
                Property Features
              </span>
            </div>
            <div className="grid mt-5 gap-x-10 gap-y-5 w-[75%] sm:grid-cols-2">
              <div className="flex gap-x-3 items-end">
                <FontAwesomeIcon
                  icon={faBed}
                  className="text-logo-second fa-2xl"
                />
                <span className=" text-xl font-semibold text-med-grey">
                  {property?.BedroomsTotal
                    ? property?.BedroomsTotal + " Bedrooms"
                    : "--"}
                </span>
              </div>
              <div className="flex gap-x-3 items-end">
                <FontAwesomeIcon
                  icon={faBath}
                  className="text-logo-second fa-2xl"
                />
                <span className=" text-xl font-semibold text-med-grey">
                  {property?.BathroomsTotalInteger
                    ? property?.BathroomsTotalInteger + " Bathrooms"
                    : "--"}
                </span>
              </div>
              <div className="flex gap-x-3 items-end">
                <FontAwesomeIcon
                  icon={faRulerCombined}
                  className="text-logo-second fa-2xl"
                />
                <span className=" text-xl font-semibold text-med-grey">
                  {property?.LivingAreaRange
                    ? property?.LivingAreaRange + " Sq Ft"
                    : property?.OfficeApartmentArea
                      ? property?.OfficeApartmentArea + " Sq Ft"
                      : property?.BuildingAreaTotal
                        ? property.BuildingAreaTotal
                        : "--"}
                </span>
              </div>
            </div>

            <h1 className="text-4xl text-black libre mt-12">
              About This Property
            </h1>
            <p
              className={`mt-6 overflow-hidden  ${!detailsOpen && property?.PublicRemarks?.length > 750
                  ? "masked max-h-44"
                  : ""
                }`}
            >
              {property?.PublicRemarks}
            </p>
            {property?.PublicRemarks?.length > 750 && !detailsOpen ? (
              <button
                onClick={() => setDetailsOpen(!detailsOpen)}
                className="bg-light-grey text-med-grey hover:shadow-md hover:text-black duration-point-three rounded-lg px-3 py-1.5 cursor-pointer shadow-sm mx-auto mt-3 w-fit block"
              >
                Show {detailsOpen ? "Less" : "More"}{" "}
                <FontAwesomeIcon
                  transform={{ rotate: detailsOpen ? 180 : 0 }}
                  icon={faAngleDown}
                />
              </button>
            ) : null}
            {/* {property?.PublicRemarksExtras ? */}

            <h1 className="text-4xl text-black libre mt-12">Additional Info</h1>

            <div className="grid md:grid-cols-2 mt-5 gap-x-10 gap-y-5">
              <div className="flex gap-x-3 ">
                <span className="text-black text-lg  font-semibold">
                  Property Type:{" "}
                </span>
                <span className=" text-lg text-med-grey">
                  {property?.PropertyType ?? "--"}
                </span>
              </div>
              <div className="flex gap-x-3 ">
                <span className="text-black text-lg  font-semibold">
                  Sub-Type:{" "}
                </span>
                <span className=" text-lg text-med-grey">
                  {property?.PropertySubType ?? "--"}
                </span>
              </div>
              <div className="flex gap-x-3 ">
                <span className="text-black text-lg  font-semibold">
                  Heating:{" "}
                </span>
                <span className=" text-lg text-med-grey">
                  {property?.HeatSource ?? "--"}
                </span>
              </div>
              <div className="flex gap-x-3 ">
                <span className="text-black text-lg  font-semibold">
                  HVAC:{" "}
                </span>
                <span className=" text-lg text-med-grey">
                  {property?.HeatType ?? "--"}
                </span>
              </div>
              <div className="flex gap-x-3 ">
                <span className="text-black text-lg  font-semibold">
                  Garage:{" "}
                </span>
                <span className=" text-lg text-med-grey">
                  {property?.GarageType ?? "--"}
                </span>
              </div>
              <div className="flex gap-x-3 ">
                <span className="text-black text-lg  font-semibold">
                  Parking:{" "}
                </span>
                <span className=" text-lg text-med-grey">
                  {property?.ParkingTotal ?? "--"}
                </span>
              </div>
              <div className="flex gap-x-3 ">
                <span className="text-black text-lg  font-semibold">
                  Exposure:{" "}
                </span>
                <span className=" text-lg text-med-grey">
                  {property?.DirectionFaces ?? "--"}
                </span>
              </div>
              <div className="flex gap-x-3 ">
                <span className="text-black text-lg  font-semibold">Lot: </span>
                <span className=" text-lg text-med-grey">
                  {property?.LotSizeRangeAcres ?? "--"} {property?.LotSizeUnits}
                </span>
              </div>
              <div className="flex gap-x-3 ">
                <span className="text-black text-lg  font-semibold">
                  Basement:{" "}
                </span>
                <span className=" text-lg text-med-grey">
                  {property?.Basement?.length
                    ? property.Basement.join(", ")
                    : "--"}
                </span>
              </div>
              <div className="flex gap-x-3 ">
                <span className="text-black text-lg  font-semibold">
                  Office:{" "}
                </span>
                <span className="text-xs text-med-grey">
                  {property?.ListOfficeName ?? "--"}
                </span>
              </div>
              <div className="flex gap-x-3 ">
                <span className="text-black text-lg  font-semibold">
                  Board:{" "}
                </span>
                <span className="text-xs text-med-grey">
                  {property?.ListAOR ?? "--"}
                </span>
              </div>
            </div>
            <p className="mt-6">{property?.PublicRemarksExtras}</p>

            <h1 className="text-4xl text-black libre mt-12">
              Affordability Calculator
            </h1>

            <iframe
              className="mb-10 md:-ml-[4.5rem] -ml-[1rem] sm:-ml-[3rem] min-[1109px]:-ml-[3rem] min-[1430px]:-ml-[6rem] min-[1552px]:-ml-[4rem] min-[1710px]:-ml-[7rem] mt-6"
              src={`https://www.mortgagecalculator.org/webmasters/?downpayment=80000&homevalue=${property?.ListPrice}&loanamount=320000&interestrate=7&loanterm=30&propertytax=2700&pmi=1&homeinsurance=1500&monthlyhoa=0`}
              scrolling="no"
              style={{
                width: "100%",
                height: windowSize > 852 ? "1200px" : "2300px",
                border: 0,
              }}
            ></iframe>
          </div>

          <div className="sticky top-4 min-w-[300px] h-fit max-[1200px]:hidden mb-10 ">
            <div className="diffuse-shadow rounded-lg py-6 px-4 h-fit bg-[#f6ffa7] ">
              <h4 className=" font-semibold text-black text-lg text-center">
                Presented By
              </h4>
              <div
                style={{ overflowClipMargin: "unset" }}
                className="rounded-full w-44 h-44 overflow-clip mx-auto my-6"
              >
                <img
                  className="w-full h-full object-cover"
                  src={constants.HEADSHOT}
                />
              </div>
              <div className="flex flex-col gap-y-2 mx-auto w-fit text-black">
                <h2 className="text-black text-2xl libre">
                  {constants.AGENT_NAME}
                </h2>
                {/* <p className="italic">{constants.AGENT_TITLE}, {constants.AGENT}</p> */}
                <p>
                  <FontAwesomeIcon icon={faPhone} className="fa-lg" />{" "}
                  {constants.AGENT_NUMBER}{" "}
                </p>
                <p className="whitespace-nowrap">
                  <FontAwesomeIcon icon={faEnvelope} className="fa-lg" />{" "}
                  {constants.AGENT_EMAIL}{" "}
                </p>
              </div>
            </div>
            <div className="diffuse-shadow rounded-lg py-6 px-4 h-fit mt-4 bg-[#f6ffa7]">
              <h4 className=" font-semibold text-black text-lg text-center">
                Inquire About This Listing
              </h4>
              <form
                ref={formRef}
                onSubmit={submitForm}
                className="mt-6 px-3 flex flex-col"
              >
                <div className="form-item">
                  <label className="form-label">Name*</label>
                  <input
                    className="form-input"
                    name="Name"
                    placeholder="Full Name"
                    value={formData.Name}
                    onChange={(e) => {
                      setFormData((prev) => ({ ...prev, Name: e.target.value }));
                      // Clear error when user starts typing
                      if (formErrors.Name) {
                        setFormErrors(prev => ({ ...prev, Name: "" }));
                      }
                    }}
                  ></input>
                  {formErrors.Name && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.Name}</p>
                  )}
                </div>
                <div className="form-item">
                  <label className="form-label">Email*</label>
                  <input
                    className="form-input"
                    name="Email Address"
                    placeholder="Email Address"
                    value={formData["Email Address"]}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        "Email Address": e.target.value,
                      }));
                      // Clear error when user starts typing
                      if (formErrors["Email Address"]) {
                        setFormErrors(prev => ({ ...prev, "Email Address": "" }));
                      }
                    }}
                  ></input>
                  {formErrors["Email Address"] && (
                    <p className="text-red-500 text-xs mt-1">
                      {formErrors["Email Address"]}
                    </p>
                  )}
                </div>
                <div className="form-item">
                  <label className="form-label">Message*</label>
                  <textarea
                    className="form-input resize-none h-32"
                    name="Message"
                    value={formData.Message}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        Message: e.target.value,
                      }));
                      // Clear error when user starts typing
                      if (formErrors.Message) {
                        setFormErrors(prev => ({ ...prev, Message: "" }));
                      }
                    }}
                  ></textarea>
                  {formErrors.Message && (
                    <p className="text-red-500 text-xs mt-1">
                      {formErrors.Message}
                    </p>
                  )}
                </div>
                <button
                  type="submit"
                  className="btn-secondary self-end"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Sending..." : "Send"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {popup && (
        <>
          <div className="backdrop" />
          <div className="popup">
            <h5 className="font-bold text-black text-lg">{popup.subject}</h5>
            <p className="font-semibold text-med-grey tracking-wide mb-3">
              {popup.message}
            </p>
            <button onClick={() => setPopup(false)} className="btn-tertiary">
              Close
            </button>
          </div>
        </>
      )}
    </>
  );
}
